export default {
  label: {
    title: 'Configurações',
    tabs: {
      style: 'Estilo',
      sharing: 'Compartilhamento',
      users: 'Usuários com acesso',
      contract: 'Adicionar Contrato',
    },
  },
};
